import React, { createContext } from 'react';
import noop from 'lodash/fp/noop';
import type { History } from 'history';
import { MFEContextType } from './MFEContext';

export interface SharedMfeConfig extends MFEContextType {
  history: History | null;
  namespace: string | null;
  broadcast: typeof noop;
}

export const FosControllerContext = createContext<SharedMfeConfig>({
  history: null,
  namespace: null,
  broadcast: noop as any,
  publish: noop as any,
  subscribe: noop as any,
  unsubscribe: noop as any,
});

export type FosControllerProps = {
  shared: SharedMfeConfig;
};

const FosControllerProvider: React.FC<FosControllerProps> = ({
  shared,
  children,
}) => (
  <FosControllerContext.Provider value={shared}>
    {children}
  </FosControllerContext.Provider>
);

export default FosControllerProvider;
